(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const ids = ['drawer-overlay', 'search-drawer', 'account-drawer', 'cart-drawer', 'luxuryTrackingPopup'];
    function reparent() {
      ids.forEach(id => {
        const el = document.getElementById(id);
        if (el && el.parentElement !== document.body) document.body.appendChild(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reparent, { once: true });
    else reparent();
  })();

  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
        this.header = null;
        this.headerBounds = { top: 0, bottom: 0 };
        this.currentScrollTop = 0;
        this._onScroll = this.onScroll.bind(this);
        this._onResize = () => { this.setHeaderHeight(); this.createObserver(); };
      }
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        if (!this.header) return;
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
                                     this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.setHeaderHeight();
        this.createObserver();
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize);
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
        if (this._observer) this._observer.disconnect();
      }
      setHeaderHeight() {
        if (!this.header) return;
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
      createObserver() {
        if (!this.header) return;
        if (this._observer) this._observer.disconnect();
        this._observer = new IntersectionObserver((entries) => {
          if (entries[0]) this.headerBounds = entries[0].intersectionRect;
          this._observer.disconnect();
        });
        this._observer.observe(this.header);
      }
      onScroll() {
        if (!this.header) return;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const headerBottom = this.headerBounds.bottom || this.header.offsetHeight;
        if (scrollTop > headerBottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.headerIsAlwaysSticky && scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else if (!this.headerIsAlwaysSticky && scrollTop < this.currentScrollTop) {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
        }
        this.currentScrollTop = scrollTop;
      }
    }
    customElements.define('sticky-header', StickyHeader);
  }

  function createFocusTrap(container) {
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let previousFocus = null;
    function handleKeydown(e) {
      if (e.key !== 'Tab') return;
      const focusables = Array.from(container.querySelectorAll(FOCUSABLE)).filter(el => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    return {
      activate() {
        previousFocus = document.activeElement;
        container.addEventListener('keydown', handleKeydown);
        const focusables = container.querySelectorAll(FOCUSABLE);
        if (focusables.length) requestAnimationFrame(() => focusables[0].focus());
        else { container.setAttribute('tabindex', '-1'); container.focus(); }
      },
      deactivate() {
        container.removeEventListener('keydown', handleKeydown);
        if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      }
    };
  }

  (function() {
    'use strict';
    const popup = document.getElementById('luxuryTrackingPopup');
    const openBtn = document.getElementById('header-tracking-open');
    const closeBtn = document.getElementById('closeLuxuryTracking');
    if (!popup) return;
    const trap = createFocusTrap(popup);
    const open = () => { popup.classList.add('active'); document.body.style.overflow = 'hidden'; trap.activate(); };
    const close = () => { popup.classList.remove('active'); document.body.style.overflow = ''; trap.deactivate(); };
    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    popup.querySelectorAll('.courier-card-luxury').forEach(card => {
      const go = () => { const url = card.getAttribute('data-tracking-url'); if (url) window.open(url, '_blank', 'noopener,noreferrer'); };
      card.addEventListener('click', go);
      card.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && popup.classList.contains('active')) close(); });
    popup.addEventListener('click', e => { if (e.target === popup) close(); });
  })();

  function initHeaderInteractions() {
    const overlay = document.getElementById('drawer-overlay');
    const searchDrawer = document.getElementById('search-drawer');
    const accountDrawer = document.getElementById('account-drawer');
    const cartDrawer = document.getElementById('cart-drawer');

    const traps = new Map();
    const getTrap = d => {
      if (!d) return null;
      if (!traps.has(d)) traps.set(d, createFocusTrap(d));
      return traps.get(d);
    };

    const lock = (b) => b ? document.body.classList.add('drawer-open') : document.body.classList.remove('drawer-open');

    function closeMegaMenu() {
      document.querySelectorAll('.header__inline-menu details[open]').forEach(t => {
        t.removeAttribute('open');
        const s = t.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('mega-menu-open');
    }

    function closeAllDrawers() {
      [searchDrawer, accountDrawer, cartDrawer].forEach(d => {
        if (d && d.classList.contains('is-open')) {
          const t = getTrap(d); if (t) t.deactivate();
          d.classList.remove('is-open');
        }
      });
      if (overlay) overlay.classList.remove('is-active');
      lock(false);
    }

    function openDrawer(drawer) {
      if (!drawer) return;
      closeAllDrawers();
      closeMegaMenu();
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-active');
      lock(true);
      const t = getTrap(drawer); if (t) t.activate();
      if (drawer === searchDrawer) {
        setTimeout(() => {
          const input = drawer.querySelector('#Search-In-Drawer');
          if (input) input.focus();
        }, 60);
      }
    }

    document.querySelectorAll('.drawer__close').forEach(btn => {
      btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); closeAllDrawers(); });
    });

    ['search-drawer-open-desktop', 'search-drawer-open-mobile'].forEach(id => {
      const btn = document.getElementById(id);
      if (btn && searchDrawer) btn.addEventListener('click', e => { e.preventDefault(); openDrawer(searchDrawer); });
    });

    const accountBtn = document.getElementById('account-drawer-open');
    if (accountBtn && accountDrawer) accountBtn.addEventListener('click', e => { e.preventDefault(); openDrawer(accountDrawer); });

    const cartBtn = document.getElementById('cart-drawer-open');
    if (cartBtn && cartDrawer) cartBtn.addEventListener('click', e => { e.preventDefault(); openDrawer(cartDrawer); });

    if (overlay) overlay.addEventListener('click', () => closeAllDrawers());
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAllDrawers(); });

    /* HOVER-ACTIVATED MEGA MENU — targets ALL <details> in the header nav */
    function initMegaMenu() {
      const isDesktop = () => window.innerWidth >= 990;
      const container = document.querySelector('.header__inline-menu');
      if (!container) return;
      const triggers = container.querySelectorAll('details');
      if (!triggers.length) return;

      let closeTimer = null;

      function clearCloseTimer() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      }

      function closeOne(trigger) {
        if (trigger.hasAttribute('open')) {
          trigger.removeAttribute('open');
          const s = trigger.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      }

      function closeAll(except) {
        clearCloseTimer();
        triggers.forEach(t => { if (t !== except) closeOne(t); });
        if (!container.querySelector('details[open]')) {
          document.body.classList.remove('mega-menu-open');
        }
      }

      function openOne(trigger) {
        clearCloseTimer();
        triggers.forEach(t => { if (t !== trigger) closeOne(t); });
        if (!trigger.hasAttribute('open')) {
          trigger.setAttribute('open', '');
          const s = trigger.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'true');
          document.body.classList.add('mega-menu-open');
        }
      }

      function scheduleClose(trigger) {
        clearCloseTimer();
        closeTimer = setTimeout(() => {
          closeOne(trigger);
          if (!container.querySelector('details[open]')) {
            document.body.classList.remove('mega-menu-open');
          }
        }, 180);
      }

      triggers.forEach(trigger => {
        const summary = trigger.querySelector('summary');
        const panel = trigger.querySelector('.mega-menu-panel');
        if (!summary) return;

        summary.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          openOne(trigger);
        });

        trigger.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          clearCloseTimer();
        });

        trigger.addEventListener('mouseleave', () => {
          if (!isDesktop()) return;
          scheduleClose(trigger);
        });

        summary.addEventListener('click', e => {
          if (!isDesktop()) return;
          e.preventDefault();
          e.stopPropagation();
          if (trigger.hasAttribute('open')) closeOne(trigger);
          else openOne(trigger);
        });

        summary.addEventListener('keydown', e => {
          if (e.key === 'ArrowDown' && panel) {
            e.preventDefault();
            const firstLink = panel.querySelector('a');
            if (firstLink) firstLink.focus();
          }
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (trigger.hasAttribute('open')) closeOne(trigger);
            else openOne(trigger);
          }
        });
      });

      document.addEventListener('click', e => {
        if (!e.target.closest('.header__inline-menu') &&
            !e.target.closest('.mega-menu-panel')) closeAll();
      });

      document.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const open = container.querySelector('details[open] summary');
        if (open) open.focus();
        closeAll();
      });

      let scrollTO;
      window.addEventListener('scroll', () => {
        if (!document.body.classList.contains('mega-menu-open')) return;
        clearTimeout(scrollTO);
        scrollTO = setTimeout(() => closeAll(), 80);
      }, { passive: true });

      container.querySelectorAll('.mega-menu-panel a').forEach(link =>
        link.addEventListener('click', () => closeAll())
      );

      window.addEventListener('resize', () => { if (!isDesktop()) closeAll(); });
    }
    initMegaMenu();

    async function refreshCart(open) {
      try {
        const res = await fetch('/?sections=header');
        if (!res.ok) throw new Error('section fetch failed');
        const data = await res.json();
        const doc = new DOMParser().parseFromString(data.header, 'text/html');

        const nextInner = doc.querySelector('#cart-drawer .drawer__inner');
        const curInner = document.querySelector('#cart-drawer .drawer__inner');
        if (nextInner && curInner) curInner.innerHTML = nextInner.innerHTML;

        const nb = doc.querySelector('.cart-count-bubble');
        const cb = document.querySelector('.cart-count-bubble');
        if (nb && cb) cb.innerHTML = nb.innerHTML;

        if (open && cartDrawer) openDrawer(cartDrawer);
      } catch (err) {
        console.warn('Cart refresh failed:', err);
      }
    }

    async function changeLine(key, quantity) {
      try {
        const r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!r.ok) {
          const body = await r.json().catch(() => ({}));
          console.warn('Cart change failed:', body.description || r.status);
        }
        await refreshCart(true);
      } catch (err) {
        console.warn('Cart change error:', err);
      }
    }

    document.addEventListener('change', e => {
      const i = e.target.closest('#cart-drawer input[data-key]');
      if (i) changeLine(i.dataset.key, Math.max(0, parseInt(i.value, 10) || 0));
    });
    document.addEventListener('click', e => {
      const b = e.target.closest('#cart-drawer .cart-item__remove');
      if (b) changeLine(b.dataset.key, 0);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshCart(true));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeaderInteractions, { once: true });
  else initHeaderInteractions();

  (function() {
    const STORAGE_KEY = 'rt-theme';

    function applyTheme(theme) {
      document.documentElement.setAttribute('data-theme', theme);
      document.documentElement.style.colorScheme = theme;
      try { localStorage.setItem(STORAGE_KEY, theme); } catch(e) {}
      document.querySelectorAll('.rt-theme-toggle__label').forEach(el => {
        el.textContent = theme === 'dark' ? 'Light mode' : 'Dark mode';
      });
      document.querySelectorAll('.rt-theme-toggle, .rt-theme-toggle-header').forEach(el => {
        el.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
      });
      if (typeof window.__rtSetMetaThemeColor === 'function') window.__rtSetMetaThemeColor(theme);
    }

    const current = document.documentElement.getAttribute('data-theme') ||
                    ((window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light');
    applyTheme(current);

    function flip() {
      const t = document.documentElement.getAttribute('data-theme') || 'light';
      applyTheme(t === 'dark' ? 'light' : 'dark');
    }

    function buildToggle() {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rt-theme-toggle';
      btn.setAttribute('aria-label', 'Toggle dark mode');
      btn.innerHTML = `
        <span class="rt-theme-toggle__icon" aria-hidden="true">
          <svg class="rt-theme-toggle__sun" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round">
            <circle cx="12" cy="12" r="4"/>
            <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>
          </svg>
          <svg class="rt-theme-toggle__moon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round">
            <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>
          </svg>
        </span>
        <span class="rt-theme-toggle__label">${document.documentElement.getAttribute('data-theme') === 'dark' ? 'Light mode' : 'Dark mode'}</span>
      `;
      btn.addEventListener('click', flip);
      return btn;
    }

    let injected = false;
    function injectToggle() {
      if (injected) return;
      const drawer = document.querySelector('.menu-drawer__inner-container') ||
                     document.querySelector('.menu-drawer__navigation-container') ||
                     document.querySelector('.menu-drawer');
      if (!drawer || drawer.querySelector('.rt-theme-toggle')) { injected = true; return; }
      const wrap = document.createElement('div');
      wrap.className = 'rt-theme-toggle-wrap';
      wrap.appendChild(buildToggle());
      drawer.appendChild(wrap);
      injected = true;
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectToggle, { once: true });
    else injectToggle();

    let scheduled = false;
    const mo = new MutationObserver(() => {
      if (injected) { mo.disconnect(); return; }
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; injectToggle(); });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 10000);

    const headerToggle = document.getElementById('rt-theme-toggle-header');
    if (headerToggle) headerToggle.addEventListener('click', flip);
  })();

  } catch(e) { console.error(e); }
})();
})();
